import React from 'react';
import { Box, Button, Modal } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { programsColumn } from './columns';
// import _ from 'lodash';
import { toast } from 'react-toastify';
// import { API_BASE_ATHENEUM } from '../../../environments';
import AddProgramForm from './AddProgramForm';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getAllProgramsAsync } from './ProgramStore/programStoreSlice';

const Program = () => {
  const [open, setOpen] = React.useState(false);

  const dispatch = useDispatch();
  const { programs } = useSelector((state) => {
    const { programReducer } = state;

    return {
      programs: programReducer.programs,
    };
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(getAllProgramsAsync())
        .unwrap()
        .then(() => {
          // toast.success('All Programs were successfully fetched.');
        });
    } catch (error) {
      toast.error('Programs could not be fetched. Please try again!');
    }
  };

  return (
    <Box>
      {/* disabled true for not breaking the ui in ath-global */}
      <Button
        onClick={handleOpen}
        variant={'contained'}
        color="primary"
        disabled={true}>
        Add Program
      </Button>
      <Box my={4}>
        <BuzzTable columns={programsColumn} data={programs} />
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <AddProgramForm fetchData={fetchData} handleClose={handleClose} />
      </Modal>
    </Box>
  );
};

export default Program;
